import { combineReducers } from "redux";
import authReducer from "./authentication/reducers";
import { userReducer } from "./users/reducers";
import { productsReducer } from "./products/reducers";
import { movementsReducer } from "./history/reducers";
import { transfersReducer } from "./transfers/reducers";
import pdfReducer from "./pdf/reducers";

const rootReducers = combineReducers({
  auth: authReducer,
  users: userReducer,
  products: productsReducer,
  movements: movementsReducer,
  transfers: transfersReducer,
  pdf: pdfReducer,
});

export type RootState = ReturnType<typeof rootReducers>;
export default rootReducers;
